import { Loader2, RefreshCw } from "lucide-react";
import type { FC } from "react";

import { Button } from "@/components/ui/button";

type Props = {
  busy?: boolean;
  onSaveAndRefresh: () => void;
};

/**
 * Strip above the editor when exhibits were renumbered while the open draft
 * has unsaved edits. A clean editor simply reloads (the server re-resolves
 * every citation on read); a dirty one cannot without losing work, so the
 * attorney is told and offered the save-then-reload in one step. Hovering a
 * citation already shows the new number: the card reads the live labels.
 */
export const StaleCitationsBanner: FC<Props> = ({
  busy = false,
  onSaveAndRefresh
}) => (
  <div
    data-testid="stale-citations-banner"
    className="flex items-center gap-2 border-b border-info-line bg-info-soft px-3 py-1.5 text-xs text-info"
  >
    <RefreshCw className="size-3.5 shrink-0" />
    <span className="min-w-0 flex-1 truncate">
      Exhibit numbering changed. Save to refresh the citations in this draft;
      hover any citation to see its current number.
    </span>
    <Button
      variant="primary"
      size="sm"
      className="h-6 gap-1 px-2 text-xs"
      disabled={busy}
      onClick={onSaveAndRefresh}
    >
      {busy ? (
        <Loader2 className="size-3 animate-spin" />
      ) : (
        <RefreshCw className="size-3" />
      )}
      Save and refresh
    </Button>
  </div>
);
